/** 进入OCR页面入口 - 枚举类型 */
export enum EntranceTypeEnum {
  /** baseInfo页 */
  BASE_INFO = 'baseInfo',
  /** verify-credit页 */
  VERIFY_CREDIT = 'verifyCredit',
}

/** 身份证上传状态 */
export enum CardUploadStatusEnum {
  /** 成功 */
  SUCCESS = 'success',
  /** 失败 */
  FAIL = 'fail',
  /** 待上传 */
  PENDING = 'pending',
  /** 删掉的 */
  DELETE = 'delete',
}

/** 页面状态 */
export enum PageStatusEnum {
  /** 初始化 */
  INIT = 'init',
  /** 处理中 */
  PENDING = 'pending',
}
